// MobilePagination component
export default function () {
    return {
        _visit(event) {
            event.preventDefault();

            const target = event.target;
            let url;

            if (target.tagName === 'A') {
                url = target.href;
            } else if (target.tagName === 'SELECT') {
                url = target.value;
            }

            target.blur();

            if (typeof this.load === 'function') {
                this.load(url);
            } else {
                if (typeof window.Bolt !== 'undefined') {
                    window.Bolt.go(url);
                } else {
                    window.location.href = url;
                }
            }
        },
    };
}
